import React from 'react';
import { memo, SVGProps } from 'react';

const VectorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 397 317' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M167.763 44.0681C194.912 39.2209 211.057 74.1035 237.134 83.0774C279.21 97.5565 338.113 73.8198 362.458 111.067C387.15 148.843 371.645 207.855 339.185 239.209C309.232 268.141 260.96 246.205 219.426 249.226C190.178 251.354 163.15 262.069 134.937 254.068C94.4221 242.578 34.3582 236.849 28.6581 195.123C22.8169 152.365 85.3339 136.706 114.568 104.961C133.548 84.3502 140.181 48.9927 167.763 44.0681Z'
      fill='#D9D9D9'
    />
  </svg>
);
const Memo = memo(VectorIcon);
export { Memo as VectorIcon };
